import React from 'react';

import { Box, Typography } from '@material-ui/core';

import { ControlledDateField } from '@vyce/core/src/components/controlled-inputs';
import { Image } from '@vyce/core/src/types';

import { COPY } from '../config';
import { PhotoThumbnails } from './PhotoThumbnails';
import { ReviewField } from './ReviewField';

interface Props {
  isCSCS: boolean;
  photos: Image[];
  onRemovePhoto: (index: number) => void;
}

export const ReviewPhase = ({ isCSCS, photos, onRemovePhoto }: Props) => {
  return (
    <Box display="flex" flexDirection="column" gridGap={16}>
      <Box>
        <Typography variant="h6">{COPY.review.title}</Typography>
        <Typography variant="body2" color="textSecondary">
          {isCSCS ? COPY.review.cscsSubtitle : COPY.review.qualificationSubtitle}
        </Typography>
      </Box>

      <PhotoThumbnails photos={photos} onRemove={onRemovePhoto} />

      <Box display="flex" flexDirection="column" gridGap={12}>
        <ReviewField name="qualification_name" label={COPY.review.fields.qualification_name} />
        <ReviewField name="issuing_body" label={COPY.review.fields.issuing_body} />
        <ReviewField name="full_name" label={COPY.review.fields.full_name} />
        <ReviewField name="reference_number" label={COPY.review.fields.reference_number} />
        <ControlledDateField name="expiry_date" label={COPY.review.fields.expiry_date} rules={{}} />
      </Box>
    </Box>
  );
};
